module.exports = __webpack_public_path__ + "static/media/garage-open.0cec7e92.svg";